import React from 'react';

import { Delimiter } from './components/Delimiter/Delimiter';
import { Step } from './components/Step/Step';
import { useStepperPresenter } from './Stepper.presenter';
import * as S from './Stepper.styles';

export const Stepper = (props) => {
  const { steps } = useStepperPresenter(props);

  return (
    <S.Container>
      <S.Wrapper>
        <Delimiter />
        {steps.map(({ key, title, ...rest }) => {
          return (
            <Step key={key} {...rest}>
              {title}
            </Step>
          );
        })}
      </S.Wrapper>
    </S.Container>
  );
};
